import { useEffect } from 'react'

import { shallowEqual } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { useAuthRoles } from 'hooks/useAuthRoles'
import { useAppSelector } from 'store/hooks'
import { State } from 'store/state'

export const useAdminRedirect = () => {
  const { isAdmin } = useAuthRoles()
  const navigate = useNavigate()

  const { companyId } = useAppSelector(
    (state: State) => ({
      companyId: state.apiHeadersReducer.companyId,
    }),
    shallowEqual
  )

  useEffect(() => {
    if (isAdmin && !companyId) {
      navigate('/admin')
    }
  }, [companyId, isAdmin, navigate])
}
